<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Menus'
 * Name: 'IconBreadcrumb'
 * FIGMA: ''
 */
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

defineOptions({
  name: 'IconBreadcrumb',
})
</script>

<template>
  <div class="icon-breadcrumb">
    <FontAwesomeIcon :icon="faChevronRight" />
  </div>
</template>

<style lang="scss" scoped src="../styles/_icon-breadcrumb.scss" />
